import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Box } from "@material-ui/core";

import { Table } from "../../../../components/table";
import TrashIcon from "../../../../assets/images/icons/trash.svg";
import { NoTableData } from "../../../../components/parts";
import { api, formatDatetime, getData } from "../../../../services";

const cellStyle = { padding: "18px 0 18px 32px" };

export const BuildingAlert = ({ buildingId, complexId }) => {
  const [alerts, setAlerts] = useState([]);
  const { cluster, segments, selectedCountries } = useSelector((state) => state.selectCSC);

  let url = `/praas/v1/buildings/portfolio-alerts/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/alerts/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/alerts/`;
  }

  useEffect(() => {
    getData(url, setAlerts);

    return () => setAlerts([]);
  }, [buildingId, complexId, cluster, segments, selectedCountries]);

  const deleteRow = (i) => {
    const alertId = alerts[i].id;

    api.delete(`${url}${alertId}/`).then(() => {
      setAlerts(alerts.filter((alert) => alert.id !== alertId));
    });
  };

  if (!alerts.length) return <NoTableData title="No alerts yet" />;

  return (
    <Box>
      <Table
        headers={["Type", "Date", "Description"]}
        data={alerts.map((alert) => [
          alert.type,
          formatDatetime(alert.created_at, "MMM DD, YYYY"),
          alert.description,
        ])}
        colWidths={[25, 18, 52, 5]}
        endIcon={TrashIcon}
        cellStyles={[cellStyle, cellStyle, cellStyle, cellStyle]}
        onEndIconClick={(i) => deleteRow(i)}
      />
    </Box>
  );
};
